import React from 'react';
import { Hero } from '../components/Hero';
import { Stats } from '../components/Stats';
import { Services } from '../components/Services';
import { Events } from '../components/Events';
import { PilotInfo } from '../components/PilotInfo';
import { Contact } from '../components/Contact';
export function HomePage() {
  return <>
      <Hero data-id="element-525" />
      <Stats data-id="element-526" />
      <Services data-id="element-527" />
      <Events data-id="element-528" />
      <PilotInfo data-id="element-529" />
      <Contact data-id="element-530" />
    </>;
}